<script setup lang="ts">
</script>

<template>
  <UiCheckoutStep :step="3" title="Paiement">
    <slot />
  </UiCheckoutStep>
</template>
